import Icon from 'assets/components/icon/Icon';
import MultilineTextInput from 'assets/components/inputs/multilineText/MultilineTextInput';
import SelectInput from 'assets/components/inputs/select/SelectInput';
import { getLocales } from 'assets/locales/Locale';
import { ClaimJobProps, usePublicClaimSubmitProvider } from '../../Claim.Submit.Hooks';

export default function ClaimSubmitClaimJobInfo({ claimJob, index }: ClaimJobProps) {
  const { lang } = getLocales();
  const { claimTypes, updateClaimJob, updateClaimJobClaimType } = usePublicClaimSubmitProvider();

  return (
    <>
      <div key={index}>
        <SelectInput
          name="claimTypeId"
          label={lang.claimType}
          data={claimTypes?.map((it) => it.displayInfo)}
          value={claimJob.claimTypeId}
          onChange={({ claimTypeId }) => updateClaimJobClaimType({ ...claimJob, claimTypeId }, index)}
          icon={<Icon class="fas-clipboard-list" />}
          error={!claimJob.claimTypeId && lang.required}
        />
        &nbsp;
        <MultilineTextInput
          name="customerComplaint"
          label={lang.customerComplaint}
          value={claimJob.customerComplaint}
          onChange={({ customerComplaint }) => updateClaimJob({ ...claimJob, customerComplaint }, index)}
        />
        &nbsp;
        <MultilineTextInput
          name="cause"
          label={lang.causeOfFailure}
          value={claimJob.cause}
          onChange={({ cause }) => updateClaimJob({ ...claimJob, cause }, index)}
        />
        &nbsp;
        <MultilineTextInput
          name="correction"
          label={lang.correctionDetails}
          value={claimJob.correction}
          onChange={({ correction }) => updateClaimJob({ ...claimJob, correction }, index)}
        />
      </div>
    </>
  );
}
